import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BondNumbersStage from "../components/bond-numbers/BondNumbersStage";
import BondNumbersSidePanel from "../components/bond-numbers/BondNumbersSidePanel";
import BondPlayGameTypeRail from "../components/bond-play/BondPlayGameTypeRail";
import { BOND_PLAY_BLUE_THEME } from "../utils/bondPlayGameTypes";
import BondPlayStageHelpButton from "../components/bond-play/BondPlayStageHelpButton";
import BondNumbersInfoModal from "../components/bond-play/BondNumbersInfoModal";
import BondGameCelebrationModal from "../components/bond-coin/BondGameCelebrationModal";
import { initBondNumbersSocket } from "../redux/bondNumbersSocket";
import {
  fetchBondNumbersConstants,
  fetchBondNumbersLanding,
  selectBondNumbersConstants,
} from "../redux/bondNumbersSlice";
import { selectAppIsAuthenticated, selectAppUser } from "../redux/appAuthSlice";
import useBondGameNotify from "../hooks/useBondGameNotify";
import "../bond-play.css";
import "../bond-draw.css";
import "../bond-coin.css";
import "../bond-dice.css";
import "../bond-numbers.css";
import "../bond-game-celebration.css";

const BondNumbers = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(selectAppIsAuthenticated);
  const user = useSelector(selectAppUser);
  const userCoin = Number(user?.COIN || 0);
  const constants = useSelector(selectBondNumbersConstants);
  const [numbersInfoOpen, setNumbersInfoOpen] = useState(false);

  const { toast, celebration, notify, clearToast, clearCelebration } = useBondGameNotify();

  useEffect(() => {
    initBondNumbersSocket(dispatch);
    dispatch(fetchBondNumbersConstants());
    if (isAuthenticated) dispatch(fetchBondNumbersLanding());
  }, [dispatch, isAuthenticated]);

  useEffect(() => {
    if (!toast) return undefined;
    const id = window.setTimeout(clearToast, 3200);
    return () => window.clearTimeout(id);
  }, [toast, clearToast]);

  return (
    <div className="bnums-page" style={BOND_PLAY_BLUE_THEME}>
      <div className="bnums-bg-glow" aria-hidden />

      <div className="bnums-layout">
        <BondPlayGameTypeRail activeGameId="bond-numbers" />

        <main className="bplay-wheel-stage bnums-stage-shell">
          <BondPlayStageHelpButton
            helpLabel="How Bond Numbers works"
            onOpenInfo={() => setNumbersInfoOpen(true)}
          />
          <BondNumbersStage
            isAuthenticated={isAuthenticated}
            userCoin={userCoin}
            onSignIn={() => navigate("/app/login")}
            onNotify={notify}
          />
        </main>

        <BondNumbersSidePanel userCoin={userCoin} onNotify={notify} />
      </div>

      {toast ? <div className="bplay-toast">{toast}</div> : null}

      <BondGameCelebrationModal
        open={!!celebration}
        {...celebration}
        onClose={clearCelebration}
      />

      <BondNumbersInfoModal
        open={numbersInfoOpen}
        onClose={() => setNumbersInfoOpen(false)}
        constants={constants}
      />
    </div>
  );
};

export default BondNumbers;
